/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import ExternalLink from '../ExternalLink';
import Link from '../Link';
import useStyles from './styles';

const Button = ({
  children,
  primary,
  isSelectedAnswer,
  geolocation,
  statuscode,
  ...rest
}) => {
  const styles = useStyles();

  //isSelectedAnswer,geolocation and statuscode are specific to geolocation component
  return (
    <button
      css={styles.btn(primary, geolocation, statuscode, isSelectedAnswer)}
      {...rest}
    >
      {children}
    </button>
  );
};

const ButtonLink = ({ children, primary, isExternal, to, ...rest }) => {
  const styles = useStyles();

  if (isExternal) {
    return (
      <ExternalLink href={to} css={styles.btn(primary)} {...rest}>
        {children}
      </ExternalLink>
    );
  }

  return (
    <Link css={styles.btn(primary)} to={to} {...rest}>
      {children}
    </Link>
  );
};

Button.Link = ButtonLink;

Button.propTypes = {
  children: PropTypes.any,
  primary: PropTypes.any,
  isSelectedAnswer: PropTypes.any,
  geolocation: PropTypes.string,
  statuscode: PropTypes.string,
};

export default Button;
